import { actionKey } from './constants';
import { createAction } from 'redux-actions';
export const logPageView = createAction(`${actionKey}/LOG_PAGEVIEW`, (payload)=>payload);
// The following action is meant to be fired when unloading a modal that logged a page view event before.
// This lets the parent "page" know that it needs to fire a new page view event, which updates the bi context fields.
export const biModalUnload = createAction(`${actionKey}.MODAL_UNLOAD`, ()=>({}));

//# sourceMappingURL=actions.js.map